import HeroSection from "@/pages/home/components/HeroSection";
import BrandsSection from "@/pages/home/components/BrandsSection";
import GallerySection from "@/pages/home/components/GallerySection";
import ServicesSection from "@/pages/home/components/ServicesSection";
import WhySection from "@/pages/home/components/WhySection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Home() {
  return (
    <>
      <HeroSection />
      <BrandsSection />
      <GallerySection />
      <ServicesSection />
      <WhySection />
      <CtaSection />
    </>
  );
}